export default __webpack_public_path__ + "static/media/recepcao.9f376d09.jpg";